import { Container } from "src/ccl/layout";
import { styled } from "src/ccl/stitches";

export const HEADER_ROW_HEIGHT = {
  mobile: 60,
  desktop: 80,
} as const;

export const HeaderFrame = styled(Container, {
  alignItems: "center",
  height: "100%",
  justifyContent: "space-between",
  maxWidth: "1720px",
});
